import { useContext } from 'react';
import { AuthContext } from '@/common/contexts/auth-context';

export const useAuthentication = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthentication must be used within an AuthProvider');
  }
  return context;
};
